import { availableDictionaryLanguages } from '@/lib/i18n/loader';
import { SUPPORTED_LANGUAGES } from '@/lib/i18n/languages';

/**
 * The switched-on languages this build can actually render, in seeded order.
 *
 * Being seeded active is the platform saying a language exists; shipping
 * `dictionaries/<code>/` is this bundle saying it can speak it. Offering a
 * language with no dictionary looks like a working choice and then renders the
 * English fallback, so only the dictionary-backed ones are listed. Adding the
 * folder is all it takes for a language to appear here - in the header menu
 * and on My Account alike.
 */
const TRANSLATED = new Set(availableDictionaryLanguages());

export const DASHBOARD_LANGUAGES = SUPPORTED_LANGUAGES.filter(
  (language) => language.active && TRANSLATED.has(language.code),
);
